// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"38":"3644a18a","82":"5a39700a","190":"1df37385","196":"24460426","374":"8f3f8ba8","394":"50e57c61","395":"b6d4d83e","875":"ec771a26","920":"ade58dd9"}[chunkId] + ".js";
};